export const POST_EMAILREQUEST_FAIL = "POST_EMAILREQUEST_FAIL";
export const POST_EMAILREQUEST_REQUEST = "POST_EMAILREQUEST_REQUEST";
export const POST_EMAILREQUEST_SUCCESS = "POST_EMAILREQUEST_SUCCESS";

export const POST_PASSWORDREQUEST_FAIL = "POST_PASSWORDREQUEST_FAIL";
export const POST_PASSWORDREQUEST_REQUEST = "POST_PASSWORDREQUEST_REQUEST";
export const POST_PASSWORDREQUEST_SUCCESS = "POST_PASSWORDREQUEST_SUCCESS";
